import { views } from "../constants/identifiers";
import workViewSelectors from "../features/workView/selectors";
import { appStateSelectors } from "../modules/appState";
import { definitionSelectors } from "../modules/definition";
import { timelineViewSettingsSelectors } from "../modules/definition/timelineViewSettings";

const shouldShowImages = state => {
  const viewType = appStateSelectors.getActiveViewType(state);
  switch (viewType) {
    case views.TIMELINE_VIEW:
      return timelineViewSettingsSelectors.getTimelineViewSettings(state).showImage;
    case views.NARRATIVE_VIEW:
      return definitionSelectors.getNarrativeViewSettings(state).showImage;
    case views.MINDMAP_VIEW:
      return definitionSelectors.getMindmapViewSettings(state).showImage;
    default:
      return false;
  }
};

export default state => {
  // If the view doesn't show images, or is not configured to show images
  // then return an empty list

  if (!shouldShowImages(state)) {
    return [];
  }
  const viewId = appStateSelectors.getActiveViewId(state);
  const items = workViewSelectors.getItemsInGroupForView(state, viewId);

  const imageUrls = items
    .map(item => item.imagePath)
    .filter(path => path)
    .toSet()
    .toList();
  return imageUrls.toArray();
};
